module.exports = __webpack_public_path__ + "static/media/eye.40df5dc1.svg";